if (!customElements.get('miyabi-variant-availability')) {
  customElements.define('miyabi-variant-availability', class extends HTMLElement {
    connectedCallback() {
      this.rule = JSON.parse(this.dataset.rule);
      this.refresh = this.update.bind(this);
      document.addEventListener('visibilitychange', this.refresh);
      this.timer = setInterval(this.refresh, 15000);
      this.update();
    }
    disconnectedCallback() {
      document.removeEventListener('visibilitychange', this.refresh);
      clearInterval(this.timer);
    }
    update() {
      const A = window.MiyabiAvailability, T = window.miyabiAvailabilityText;
      if (!A || !T) return;
      const now = A.clock(), next = A.earliest([this.rule], A.blocks(this.dataset.blocked), now);
      const lead = A.readiness(this.rule, now).lead;
      let text = T.soldOut;
      if (this.dataset.available === 'true' && next) {
        text = next.day === A.calendar(now).day ? T.pillToday :
          (lead > 0 ? T.pillPreorder.replace('__DAYS__', lead) : T.pillFrom).replace('__DATE__', A.dateText(next.day));
        if (this.dataset.dateLabel) text = this.dataset.dateLabel.replace('__DATE__', A.dateText(next.day)).replace('__TIME__', A.timeText(next.slot.start));
      } else if (next && A.parseDate(this.rule.date) > A.calendar(now).day) {
        text += ' · ' + T.pillFrom.replace('__DATE__', A.dateText(next.day));
      }
      if (this.textContent !== ' · ' + text) this.textContent = ' · ' + text;
    }
  });
}
